<template>
    <b-modal ref="mdlVisualizzaAnagrafica" size="xl" :title="titoloModal" centered no-close-on-backdrop no-close-on-esc hide-header-close>
        <div>
            <b-card class="sa-card" header="Anagrafica" header-tag="header" footer-tag="footer" title="">
                <b-row>
                    <!-- <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Tipo:</label>
                        <span class="sa-data">{{ jsonData.descrizioneTipo }}</span> -->
                    <!-- <b-form-input v-model="jsonData.nomeMedicoPresente" placeholder="Nome"></b-form-input> -->
                    <!-- </b-col> -->
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">Codice:</label>
                        <span class="sa-data">{{ jsonData.codice }}</span>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Nominativo:</label>
                        <span class="sa-data">{{ jsonData.nominativo }}</span>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Città:</label>
                        <span class="sa-data">{{ jsonData.citta }}</span>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Indirizzo:</label>
                        <span class="sa-data">{{ jsonData.indirizzo }}</span>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Codice Fiscale:</label>
                        <span class="sa-data">{{ jsonData.codiceFiscaòe }}</span>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Partita I.V.A.:</label>
                        <span class="sa-data">{{ jsonData.partitaIva }}</span>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Telefono:</label>
                        <span class="sa-data">{{ jsonData.telefono }}</span>
                    </b-col>
                    <!--<b-col v-if="attivaFattura" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">Descrizione Fattura:</label>
                        <span class="sa-data">{{ jsonData.descrizioneUno }}</span>
                    </b-col>
                    <b-col v-if="attivaFattura" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">Note Fattura:</label>
                        <span class="sa-data">{{ jsonData.noteUno }}</span>
                    </b-col>
                    <b-col v-if="attivaArchivio" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">Descrizione Archivio:</label>
                        <span class="sa-data">{{ jsonData.descrizioneDue }}</span>
                    </b-col>
                    <b-col v-if="attivaArchivio" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">Note Archivio:</label>
                        <span class="sa-data">{{ jsonData.noteDue }}</span>
                    </b-col>-->
                </b-row>
                <b-table sticky-header ref="table" stacked="lg" striped hover :items="jsonData.listaNote" :fields="fields" :current-page="1" :per-page="100000" sort-icon-left head-variant="light">
                    <template v-slot:cell(tipo)="{ item }">
                        <span class="sa-label-data" v-if="item.tipo === 'P'">PRINCIPALE</span>
                        <span class="sa-label-data" v-if="item.tipo === 'A'">ARCHIVIO</span>
                    </template>
                </b-table>
            </b-card>
        </div>
    </b-modal>
</template>

<script>
import Vue from "vue";
import UtilityMixin from "../../utility/UtilityMixin";
// import DatePicker from "vue2-datepicker";
export default {
    mixins: [UtilityMixin],
    // components: { DatePicker },
    data() {
        return {
            isNew: true,
            isReadonly: false,
            isRequired: false,
            attivaFattura: false,
            attivaArchivio: false,
            pathResource: "/anagrafica",
            pathResourceTipiAnagrafica: "/dizionariotipi",
            titoloModal: "",
            tipoAnagraficaOptions: [],
            jsonData: {},
            fields: [
                {
                    label: "Tipo",
                    key: "tipo",
                    thStyle: "width: 15rem",
                    sortable: true,
                },
                {
                    label: "Descrizione",
                    key: "descrizione",
                    // thStyle: "width: 5rem",
                    sortable: true,
                },
                {
                    label: "Note",
                    key: "note",
                    // thStyle: "width: 5rem",
                    sortable: true,
                },
            ],
        };
    },
    methods: {
        openModal(item) {
            let me = this;
            me.impostaPermessi();
            me.loadData(item.id);
            me.titoloModal = "Visualizza Anagrafica";
            me.jsonData = {};
        },
        loadData(id) {
            let me = this;
            // me.$emit("beforloadData");
            let link = process.env.VUE_APP_PATH_API + this.pathResource + "/" + id;
            UtilityMixin.methods.restCallGet(link, null, me.ripristinaRigaSuccess, me.ripristinaRigaError);
            me.$refs.mdlVisualizzaAnagrafica.show();
        },

        ripristinaRigaSuccess(response) {
            let me = this;
            me.jsonData = response.data.data;
        },
        ripristinaRigaError(response) {
            console.log(response);
        },

        impostaPermessi() {
            let me = this;
            me.attivaFattura = false;
            me.attivaArchivio = false;
            me.attivaFattura = UtilityMixin.methods.verificaPermessi(Vue.prototype.user, "articolifattura", 1);
            me.attivaArchivio = UtilityMixin.methods.verificaPermessi(Vue.prototype.user, "articoliarchivio", 1);
        },
    },
};
</script>
